function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawGardening = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1133.35 824.13",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 967.37,
    y1: 836.76,
    x2: 967.37,
    y2: 224.41,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 581.82,
    y1: 814.13,
    x2: 581.82,
    y2: 77.35,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M350.99 779.89c-8 2-16.28-.33-24.47-.43s-17.75 3.35-19.76 11.29c-2.7 10.67 9.78 18.72 20.46 21.37 41.45 10.32 85.33-3.07 127.7 2.39 17.85 2.3 35.22 7.93 53.17 9.28 41.09 3.07 81.23-16.47 122.38-14.26 20.61 1.1 40.65 7.65 61.26 8.7 49.32 2.51 98-26.44 146.27-16.07 13.67 2.9 26.43 8.9 39.94 12.36 34.16 8.75 70.11 1 104.5-6.85 6.83-1.55 15.06-4.56 15.9-11.51.93-7.67-7.88-12.48-15.2-14.93-80.11-26.79-165.89-41-249.45-28.6-19 2.82-38 7-57.2 6.73-42.54-.61-81.64-22.81-123.41-30.92-79.14-15.38-158.27 20.5-230.92 55.46M48.74 63.56c12 17.23 8.88 41.53-.3 60.41s-23.45 34.56-33.87 52.73c-20.78 36.25-21.5 90.18 12 114.69 7.22 5.29 15.86 9.17 20.72 16.81 6.7 10.54 4 24.41 1 36.58l-.24 1c-11.25 46.07 17.17 92.88 62.32 102.28 25 5.21 48.1 15.45 66.35 34 15.95 16.2 26.36 37.16 37.83 57 20.72 35.83 46.15 69.53 79 93.76s73.91 38.32 113.73 32.68c91-12.88 147.9-119.43 238.6-134.13 6.53-1.06 13.57-1.53 19.45 1.65 8.31 4.49 11.77 14.63 16 23.31 22.23 46 76.55 62.66 124.86 74.59l90.84 22.41c49.32 12.17 101 24.34 149.95 11.26s93.08-60.4 85.53-112.24c-6.21-42.59-44.35-76.68-44.27-119.7.05-29.74 18.77-56.65 19.29-86.38.54-30.94-18.64-58.61-39.7-80.74-60.62-63.71-141.51-101.47-220.38-137.77-55.57-25.59-111.41-51.28-170.08-67.7C532.75 19.7 380.3 37.9 230.77 38.29c-25.72.07-52.64-.2-77.18-9.43-18.83-7.08-35-26.29-55.07-28.64-15.32-1.78-36.75 7.4-49 16.29-22.5 16.25-14.74 27.06-.78 47.05z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1068.18 324a8.76 8.76 0 0 0 0-1.18c-.36-4.88-5-8.41-9.6-10.29s-9.74-2.8-13.81-5.65c-6.88-4.82-9-13.83-9.62-22.07-.19-2.56-.27-5.12-.28-7.69s.16-5.41.4-8.11c.4-4.48 1.06-9.12 1-13.61a26.15 26.15 0 0 0-2.4-12.45c-4.08-8.06-13.24-12.18-21.72-15.69-3.26-1.35-6.6-2.72-10.14-2.87-3.74-.16-7.38 1.05-10.92 2.25-5.62 1.9-11.32 4.37-17.13 5.66-3.26.72-6.83.18-10 1.33-6.22 2.28-7.55 7.87-7.45 14v1.16c-.62-.57-1.26-1.11-1.91-1.63l-.38-.3q-1-.81-2.13-1.53l-.36-.23a35.84 35.84 0 0 0-4.79-2.61l-.25-.11q-1.25-.55-2.54-1l-.16-.06a36.46 36.46 0 0 0-5.46-1.44A36.37 36.37 0 0 0 906 250.07l-6.87 7c-31.23-7-32.63 20.13-32.63 20.13l.23-.05-.08.19c1 4.69 37.28 76.13 37.28 76.13 16.76 11.91 34.18 27.87 34.18 27.87s-10.78 5.71-6.78 31.86c4.89 32-2.46 77.55-2.46 77.55v29.46l1.38-.38c-.17 1-.35 2-.52 3.15a168.08 168.08 0 0 0-.86 44.72c3.7 31.26 18.48 73.94 18.48 73.94s5.54 15 6.78 27.05a25.22 25.22 0 0 0 1.58 6.95 55.26 55.26 0 0 1 4.32 20.87c0 13.08 1.71 32.71 9.5 52.74 6.25 16.08 8.56 25.5 9.25 31-4.43 5.86-10.22 12.25-14.79 12.89-8.62 1.2-25.26 2.4-14.17 16.83a10.21 10.21 0 0 0 1.29 1.37c-8.42 1.36-17.68 4.36-8.68 16.06 11.09 14.43 76.39 7.82 76.39 7.82s.42-8 0-16.82c4.58-.32 7.41-.61 7.41-.61s1.85-34.87-6.16-39.08a16.9 16.9 0 0 0-4.32 1.06c-.86-4.82-1.52-10.81-1.93-15.25l3.17-.24V712s-3.7-32.46-17.25-46.89a29.15 29.15 0 0 1-4.43-6c.1-4.17.11-10 .06-16.73a13.89 13.89 0 0 1 1.91-2.52s7.39-9 32.65-66.13c14.9-33.69 11.58-53.14 6.35-63.44-1-3.66-3.6-14.11-7-33.35-4.31-24.65.62-48.7.62-48.7s16-41.48 23.41-58.31a27.39 27.39 0 0 0 2.08-12.85c1.93-1.41 2.86-3.76 3.69-6l7.59-20.25c.82-2.19 1.66-4.47 1.48-6.8zM965.1 287.59a30.8 30.8 0 0 0 2.75 3.66s-1.13-1.18-3-3.08c.1-.17.15-.39.25-.58zm-37.32 41.57l20.89-21.34c7.22 6.6 14.95 13.34 21.41 18.89a61.84 61.84 0 0 1-2.44 8.37c-2.8 1.39-6.5 1.84-11-.61-7.12-3.86-20.31-5-28.86-5.31z",
    transform: "translate(-33.33 -37.94)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M886.67 209.47s-15.49 8.94-10.73 21.45c0 0 16.09 4.77 22.64 16.69s57.21 54.82 57.21 54.82l36.88-18.48s-12.85-17.16-53.5-29.14c0 0-24-25.69-32.31-30.45s-20.19-14.89-20.19-14.89z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M886.67 209.47s-15.49 8.94-10.73 21.45c0 0 16.09 4.77 22.64 16.69s57.21 54.82 57.21 54.82l36.88-18.48s-12.85-17.16-53.5-29.14c0 0-24-25.69-32.31-30.45s-20.19-14.89-20.19-14.89z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M887.25 706.73A77.61 77.61 0 0 0 874 694.39q1.53-1.11 3-2.23c12.62-9.38 23.43-19 25.75-25.91 6.2-18.33 69.77-51.93 69.77-51.93s-65.12 12.22-99.23-7.64c-20.35-11.85-51.74-13.91-73.75-13.64l.16-.38.3-.66c.17-.37.34-.73.52-1.1s.29-.6.45-.9l.13-.24c.23-.44.47-.88.72-1.32.61-1.08 1.26-2.16 1.95-3.24v-.06a87.18 87.18 0 0 1 5.77-7.88l.08-.1c1.65-2 3.37-4 5.1-5.83l.1-.11 1.22-1.29.2-.2c1.65-1.73 3.3-3.37 4.9-4.9l.37-.35 1-.91.46-.43.89-.83.47-.43 1.33-1.2.72-.64.54-.47.79-.69.4-.34 1-.88.09-.08c3.23-2.76 5.36-4.37 5.36-4.37h-.05a29.41 29.41 0 0 1-3.21 2l-.15.07-1 .5-.28.13-.89.4-.5.2-.7.29-.68.25-.55.2-.86.29-.4.13-1.1.33-.18.05-1.3.35c-22.62 5.83-54.77-2.79-57.72-3.61l-.19-.05s-12.92-2.67-29.66-5.07a1199.15 1199.15 0 0 1 22.73-44.12 67.45 67.45 0 0 0 30 31.7c.5-.56 1-1.14 1.42-1.72 1.5.86 2.39 1.27 2.39 1.27a38 38 0 0 0 8.47-16.8 62.43 62.43 0 0 0 14.45 10.24q.65-.73 1.25-1.49c.61.32.94.48.94.48 8.37-9.43 10.59-21.61 9.65-34a68.74 68.74 0 0 0 48.35.21v-.19c1.44-.49 2.23-.83 2.23-.83-1.26-9.27-6-17-12.44-23.42 29.88.62 46-17.9 46-17.9l-.17-.23c1.23-1.15 1.85-1.86 1.85-1.86a53.17 53.17 0 0 0-14.68-14c13.64-8.07 19.55-18.52 19.55-18.52-.34-.32-.7-.63-1-.94.75-1.08 1.12-1.73 1.12-1.73-.75-.71-1.53-1.38-2.31-2 .51-.77.76-1.21.76-1.21-12-11.29-27.92-15.36-43.71-15.83a66.39 66.39 0 0 0 16.75-38.2c-12-3.91-24.26-1.21-35.42 4.41a67.55 67.55 0 0 0-4.38-30.52 56.48 56.48 0 0 0 9.83 6.08q.64-.74 1.23-1.51c.61.31 1 .46 1 .46 8.22-9.56 10.24-21.77 9.11-34.1a68.74 68.74 0 0 0 48.35-.54v-.19c1.43-.51 2.21-.86 2.21-.86-1.41-9.25-6.23-16.91-12.81-23.23 29.88.16 45.71-18.61 45.71-18.61l-.18-.23c1.21-1.17 1.82-1.89 1.82-1.89a53.21 53.21 0 0 0-14.9-13.72c13.51-8.28 19.25-18.82 19.25-18.82-.35-.32-.71-.62-1.06-.93.73-1.1 1.09-1.75 1.09-1.75-.76-.7-1.55-1.36-2.34-2 .5-.78.75-1.22.75-1.22-12.17-11.1-28.16-14.93-44-15.15a66.36 66.36 0 0 0 16-38.42c-12.1-3.73-24.27-.83-35.34 5a65.87 65.87 0 0 0-6-32.87c-.82.17-1.62.37-2.41.58-.19-.4-.3-.6-.3-.6-.32-.7-.52-1.08-.52-1.08-13.73 2.77-23.58 12.66-30.58 24.54-.52.88-1 1.77-1.51 2.67a67.29 67.29 0 0 0-25.9-31.28c-10.23 9.65-13.18 23.37-12.62 37.25 0 .94.1 1.88.16 2.82a68.65 68.65 0 0 0-40.92-14.54c-2.11 8.24-1.11 16.35 1.79 24a68.09 68.09 0 0 0-29.95 2.09v.39c-1.43.38-2.22.66-2.22.66.78 11.62 7 21.23 15.57 29A68.32 68.32 0 0 0 723.89 231q.5.88 1 1.71c-.7.61-1.06 1-1.06 1 6.11 10.79 16.8 16.93 28.73 20.26a67.14 67.14 0 0 0-27.21 31.12c.29.2.58.39.87.59-.61 1.32-.89 2.09-.89 2.09 10.19 7.26 22.55 8.37 34.82 6.4a68.17 68.17 0 0 0-2.46 21.71c-7.53 10.57-15.17 21.63-22.71 32.82-1.36-.08-2.12-.07-2.12-.07a36 36 0 0 0-.93 4.61c-4.16 6.2-8.28 12.42-12.33 18.59a61.41 61.41 0 0 0-15.31 2.47v.39c-1.43.36-2.23.62-2.23.62v.48c-6.7-9.05-16.08-15.82-26.19-20.87a67.53 67.53 0 0 0 31.64-27.56c-9.21-8.58-21.44-11.25-34-10.83a65.91 65.91 0 0 0 9.28-32.12c-.81-.21-1.62-.37-2.43-.52v-.67-1.19c-13.57-3.46-26.82 1.17-38.42 8.81-.86.57-1.71 1.15-2.55 1.75a66.22 66.22 0 0 0-9.32-39.31c-13.5 4.25-22.26 15.29-27.94 28-.39.86-.75 1.73-1.11 2.61a67.52 67.52 0 0 0-30.28-30.77c-5.57 6.49-8.28 14.21-9.1 22.35a67.77 67.77 0 0 0-27.84-11.08l-.14.37c-1.45-.28-2.29-.37-2.29-.37-4.48 10.78-3.14 22.12 1 32.81a69 69 0 0 0-39.22-.44c0 .67.09 1.33.17 2-.9.25-1.38.41-1.38.41.68 12.34 7.54 22.48 16.78 30.63a68.39 68.39 0 0 0-38.14 16.2c.17.31.35.6.52.9-1.13.92-1.73 1.49-1.73 1.49 5.92 10.93 16.53 17.28 28.42 20.82a65.94 65.94 0 0 0-14.73 26.46c.9.48 1.8.91 2.72 1.32-.2.69-.29 1.08-.29 1.08 12.75 6.89 27.34 5.26 40.9.26-4.11 28.47 12.82 48.56 12.82 48.56.69-.3 1.37-.62 2-1 1 1.4 1.61 2.15 1.61 2.15a38.68 38.68 0 0 0 15-11.67 61.27 61.27 0 0 0 8.67 15.32q.91-.39 1.78-.83c.41.54.65.83.65.83a38.66 38.66 0 0 0 15-11.62c1.33 29.16 2.47 77.26-.83 126.87-2 30.28-5.67 61.13-12 88.59-11.47-47.45-26.26-104.93-41.23-152.74-16.32-52.13-47.76-101.91-76.93-148.28-20.81-33.07-47.17-73.64-71.89-107.83 22.94 7.62 41-.38 41-.38s0-.19-.06-.28c1.61-.52 2.48-.91 2.48-.91a52.26 52.26 0 0 0-7.27-18.78c15.83-1.59 25.69-8.58 25.69-8.58-.17-.44-.36-.86-.54-1.29 1.15-.67 1.76-1.1 1.76-1.1-.38-1-.79-1.89-1.22-2.81.8-.48 1.22-.78 1.22-.78-6-15.24-18.65-25.6-32.74-32.63A67.53 67.53 0 0 0 443 151.6c-9.21-8.58-21.44-11.25-34-10.83a65.91 65.91 0 0 0 9.28-32.12c-.81-.21-1.62-.37-2.43-.52v-.67-1.19c-13.57-3.46-26.82 1.17-38.42 8.81-.86.57-1.71 1.15-2.55 1.75a66.22 66.22 0 0 0-9.32-39.31c-13.5 4.25-22.26 15.29-27.94 28-.39.86-.75 1.73-1.11 2.61a67.52 67.52 0 0 0-30.28-30.77c-5.57 6.49-8.28 14.21-9.1 22.35a67.77 67.77 0 0 0-27.84-11.08l-.14.37c-1.45-.28-2.29-.37-2.29-.37-4.48 10.78-3.14 22.12 1 32.81a69 69 0 0 0-39.22-.44c0 .67.09 1.33.17 2-.9.25-1.38.41-1.38.41.68 12.34 7.54 22.48 16.78 30.63A68.39 68.39 0 0 0 206 170.21c.17.31.35.6.52.9-1.13.92-1.73 1.49-1.73 1.49 5.92 10.93 16.53 17.28 28.42 20.82a65.94 65.94 0 0 0-14.73 26.46c.9.48 1.8.91 2.72 1.32-.2.69-.29 1.08-.29 1.08 12.75 6.89 27.34 5.26 40.9.26-4.11 28.47 12.82 48.56 12.82 48.56.69-.3 1.37-.62 2-1 1 1.4 1.61 2.15 1.61 2.15a38.68 38.68 0 0 0 15-11.67 61.26 61.26 0 0 0 8.67 15.32q.91-.39 1.78-.83c.41.54.65.83.65.83 11.64-5 18.9-15.12 23.39-26.69 16.33 17.13 37.1 19.92 42.4 20.36 30.4 42.94 67.31 98.74 90.76 146.92 0 0 48.25 93.23 79 190.95-15.63-16.5-37-40.44-41.79-52.71-7.75-19.86-103.88 0-103.88 0l-.19.05c-3 .82-35.1 9.44-57.72 3.61l-1.28-.35-.18-.05-1.1-.33-.4-.13-.86-.29-.55-.2-.68-.25-.7-.29-.5-.2-.89-.4-.28-.13-1-.5-.15-.07a29.41 29.41 0 0 1-3.21-2h-.05a171.25 171.25 0 0 1 24 22.87l.23.28 1.26 1.54.33.41q.62.78 1.22 1.56l.24.31q.69.92 1.36 1.85l.33.48q.47.66.92 1.33l.52.78.67 1 .55.88.56 1c.18.31.37.62.54.93l.07.13c.29.53.58 1.05.85 1.58l.28.57q.35.7.66 1.39l.23.51.18.43c-22-.27-53.4 1.79-73.75 13.64-34.11 19.86-99.23 7.64-99.23 7.64s63.57 33.6 69.77 51.93c2.48 7.32 14.57 17.79 28.23 27.74l2.94 2.12a76.72 76.72 0 0 0-11 10.62C245.38 743.39 171 780 171 780h.22l.64.06 1.1.1 2 .19h.34c15.92 1.5 72 7.27 104 16.89 1.15.35 2.27.7 3.35 1.05 9.3 3.05 62-1.53 97.68-12.22 1-.3 2-.57 3-.83l.89-.22q1.12-.27 2.25-.51l.89-.19c1-.2 2-.39 3-.55h.06c1-.17 2-.31 3-.44l.91-.11 2.19-.24.95-.09q1.36-.12 2.71-.19h.29c1-.05 1.93-.09 2.9-.11H409.43l1.4.05 2 .1 1.43.1 1.24.1 1.59.14.75.08 1.71.18 1.22.15.92.12 1.35.19.75.11c0 .21-.08.44-.12.66 0 0 1.29 7.19 9.75 14.22-14.33 4.12-26.22 8.86-35.1 14-.53.29-1 .6-1.52.9.36 0 .71-.08 1.09-.11s.67 0 1 0h365.56c.33 0 .71.06 1.07.11a8.86 8.86 0 0 1 .88.14 6.28 6.28 0 0 1 .93.2q-1-.64-2-1.24c-11.1-6.48-26.9-12.23-46.25-17 5.81-3 9.05-6.4 10.4-10 1.14-.26 2.3-.51 3.51-.75a132.79 132.79 0 0 1 14.32-2.11l2-.16 1-.08a94.29 94.29 0 0 1 33 3.32c35.66 10.69 88.37 15.27 97.68 12.22 1.08-.36 2.2-.71 3.35-1.05 31.93-9.61 88-15.39 104-16.89h.34l2-.19 1.1-.1.64-.06h.22s-74.38-36.55-105.39-73.21zm-42.75-377.8l-.5.07c0-.16.07-.32.1-.48zm-150.89 83.35a68.847 68.847 0 0 0-5.74 3.45 53.47 53.47 0 0 0-6.08-13.59 61.46 61.46 0 0 0 22.54-6.71c-3.69 5.75-7.27 11.39-10.72 16.85zm6.73 28.11a64.67 64.67 0 0 0 9.51 3.6 67.21 67.21 0 0 0-19.76 17.37c3.16-6.93 6.6-13.94 10.26-20.97zM601.56 567c2.82-46.59 4.54-97 2.14-132.49a68.46 68.46 0 0 0 32.31 11l.05-.19c1.51.16 2.37.19 2.37.19 2.85-8.92 1.94-17.88-1.16-26.41a63.71 63.71 0 0 0 44.44 4.69 36.37 36.37 0 0 0 2.38 3.69c-19.35 31-32.52 53.25-32.52 53.25-13.41 20.17-35.51 90.7-55.6 161.54 1.85-21.16 3.91-47.56 5.59-75.27zm59.33-12.22c-3.7 9.48-17.29 25.91-30.49 40.51 17.32-43.61 34.68-80.55 44.37-100.42 2.75-5.63 5.39-11.31 8-17 9.95 7 22 8.21 34 6.48a65.35 65.35 0 0 0-1.92 30.12c1 .06 2 .07 3 .05.12.71.2 1.09.2 1.09a38.1 38.1 0 0 0 13.53-1.61c-5.34 10.82-10.69 22-15.94 33.33-24.98-2.51-50.88-2.49-54.75 7.42zM845.38 330.6c-.18-.4-.29-.61-.29-.61-.2-.45-.35-.77-.43-.94q.79.7 1.57 1.34zm-69.12-7.27c8.52-2.92 16.07-8.59 22.59-15.37a66.28 66.28 0 0 0 24.29 32.7A66 66 0 0 0 813.6 353c-.53.87-1 1.76-1.55 2.65a67.25 67.25 0 0 0-25.4-31.68c-10.39 9.49-13.55 23.16-13.21 37 0 .94.07 1.88.12 2.83a66.47 66.47 0 0 0-18.93-10.8c7.37-10.48 14.68-20.44 21.63-29.67z",
    transform: "translate(-33.33 -37.94)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M524.39 590.06s-49.7-49.7-57.23-69.27-100.9 0-100.9 0-46.68 13.55-67.77-1.51c0 0 33.13 25.6 36.14 46.68s120.48 75.3 120.48 75.3l69.28 64.8 24.1-13.55z",
    fill: "#7fb72b"
  }), React.createElement("path", {
    d: "M550.49 692.5l-24.1 13.56-19.34-18.07-49.94-46.68S339.67 587.06 336.67 566a35.63 35.63 0 0 0-4.37-12c-9.5-17.24-30.62-33.81-31.73-34.68 21.1 15 67.72 1.48 67.72 1.48s93.37-19.58 100.9 0 57.2 69.26 57.2 69.26z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M516.86 687.98h-11.8l-49.94-46.68S337.67 587.06 334.67 566a35.63 35.63 0 0 0-4.37-12 263.85 263.85 0 0 1 28.46 1.43c33.13 33.13 79.81 49.7 79.81 49.7 46.67-30.07 78.29 82.85 78.29 82.85z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M515.36 692.5h-57.23l-155.11-6s-23.35-13.63-43.35-28.44c-13.27-9.8-25-20.13-27.42-27.35-6-18.07-67.77-51.2-67.77-51.2s63.25 12 96.38-7.53 96.38-12 96.38-12c33.13 33.13 79.81 49.7 79.81 49.7 25.89-16.7 47.14 10.59 60.95 38.21a285.61 285.61 0 0 1 17.36 44.61zM568.07 590.06s49.7-49.7 57.23-69.27 100.9 0 100.9 0 46.68 13.55 67.77-1.51c0 0-33.13 25.6-36.14 46.68s-120.48 75.3-120.48 75.3l-69.28 64.8-24.1-13.55z",
    fill: "#7fb72b"
  }), React.createElement("path", {
    d: "M796.91 519.34c-1.11.87-22.23 17.45-31.73 34.7a35.44 35.44 0 0 0-4.37 12c-3 21.08-120.48 75.3-120.48 75.3l-49.94 46.68-19.32 18.04-24.1-13.55 24.1-102.45s49.7-49.7 57.23-69.27 100.9 0 100.9 0 46.61 13.57 67.71-1.45z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M518.92 674.06c-2.1 1.95-5.63 3.57-5 6.37a4.64 4.64 0 0 0 1.62 2.36c3.92 3.48 10.27 6.19 9.74 11.41-.3 3-2.92 5.13-4.2 7.83-2.67 5.64 1.54 12.83 7.47 14.77s12.57-.34 17.46-4.23c1.05-.84 2.17-1.79 3.51-1.79a9.49 9.49 0 0 1 2.94.91c4 1.38 8.51-1.68 10.22-5.59s1.4-8.37 1.05-12.62c2.27 1.93 6 .88 7.93-1.41s2.49-5.38 3-8.32l3.57-20.61c2.86-.83 4-4.69 2.69-7.36s-4.36-4.13-7.32-4.41-5.92.39-8.84.95a112 112 0 0 1-23.19 2c-6.45-.13-14.73-8.09-18.29-1-3.24 6.31 1.53 15.25-4.36 20.74zM762.18 554.06a35.44 35.44 0 0 0-4.37 12c-3 21.08-120.48 75.3-120.48 75.3l-49.94 46.68h-13.3s31.58-112.98 78.31-82.89c0 0 46.68-16.57 79.81-49.7a268.45 268.45 0 0 1 29.97-1.39z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M927.99 579.55s-61.74 33.13-67.77 51.2c-2.26 6.78-12.76 16.29-25 25.54-20.45 15.45-45.77 30.18-45.77 30.18l-155.11 6H577.1a288 288 0 0 1 15-39.76c13.67-29.12 35.89-60.75 63.29-43.07 0 0 46.68-16.57 79.81-49.7 0 0 63.25-7.53 96.38 12s96.41 7.61 96.41 7.61z",
    fill: "#7fb72b"
  }), React.createElement("path", {
    d: "M784.92 232.43s-93.48 108.63-133.33 201.03c-4.1 9.51-8.33 19-12.81 28.29-23.9 49.74-95.81 208-93.3 307l-27.11 5.77s69.3-283.07 97.89-326.74c0 0 126.5-216.86 168.67-237.94z",
    fill: "#936868"
  }), React.createElement("path", {
    d: "M567.67 532.87c-1.63 27.36-3.63 53.4-5.41 74.21-.35 4.28-.71 8.33-1 12.14-1.84 20.86-3.21 34.08-3.21 34.08v.08c-.35 6.52-2.38 16.43-5.66 28.76-1.08 4.08-2.32 8.43-3.66 13-.26.83-.5 1.67-.75 2.51q-1.72 5.78-3.69 12c-.54 1.69-1.08 3.4-1.64 5.14-3 9.38-6.36 19.38-10 29.8-3.25 9.41-6.7 19.16-10.27 29.09l-.59 1.61c-.09.24-.18.5-.27.75h-18.85c.08-.26.15-.51.21-.75 2.88-10.2 5.53-20.19 8-29.89s4.79-19.28 6.9-28.34q1.29-5.53 2.48-10.81c.26-1.14.51-2.27.75-3.39.12-.5.23-1 .33-1.48.54-2.39 1.05-4.74 1.54-7 .2-.84.38-1.69.56-2.51l.45-2.11c1.13-5.27 2.17-10.27 3.12-14.94a1442.837 1442.837 0 0 0 4.6-23.68c2-10.69 3-16.85 3-16.85a3.46 3.46 0 0 0 .11-.42c1.22-4.44 2.35-9 3.39-13.66 6.11-27.08 9.68-57.5 11.63-87.36 5.14-78.4-.81-153-.81-153l13.33-18.24c11.29 22.02 9.59 101.02 5.41 171.26zM752.21 414.6s-27.54 44.46-54.83 101.22q-4 8.36-8 17a738.11 738.11 0 0 0-27.71 68.61c-.77 2.24-1.52 4.49-2.24 6.72-1.36 4.17-2.65 8.33-3.86 12.44-.48 1.61-.95 3.22-1.39 4.82q-1.29 4.56-2.44 9.05c-1.11 4.38-2.12 8.72-3 13 0 0-5.66 17.41-13.33 45-.48 1.78-1 3.58-1.49 5.44-.35 1.28-.71 2.59-1.07 3.92-2.74 10.2-5.69 21.5-8.67 33.64-1 4.16-2 8.4-3.06 12.76-2.06 8.72-4.13 17.8-6.13 27.12 0 .26-.11.5-.15.75h-18.9c0-.26.08-.51.11-.75 1.3-9.94 2.61-19.65 4-29 .95-6.7 1.93-13.24 2.91-19.52 1.72-11.05 3.48-21.38 5.23-30.69.24-1.22.47-2.42.69-3.6v-.14a291.23 291.23 0 0 1 7.59-31.55 72 72 0 0 1 2.71-7.2s2.55-6.54 7-17.54l2.26-5.65c3-7.3 6.52-16.05 10.57-25.84.56-1.37 1.14-2.77 1.73-4.19 8.24-19.83 18.27-43.43 29-67.53 2.88-6.46 5.8-13 8.76-19.41 25.36-55.42 53.04-108.94 70.17-121.18z",
    fill: "#936868"
  }), React.createElement("path", {
    d: "M292.48 170.69s94.12 121.23 138.55 213.84c0 0 103.91 203.8 100.9 322.52l27.11 5.77s-30.12-143.12-61-243.21c-15.85-51.4-46.39-100.47-74.72-146.19-40.78-65.79-103.52-161.66-130.84-175.36zM728.67 776.54a6 6 0 0 0-.9-.2 8.48 8.48 0 0 0-.86-.14c-.35 0-.69-.09-1-.11s-.65 0-1 0H369.82c-.34 0-.71.06-1.05.11.48-.3 1-.6 1.48-.89 8.63-5.11 20.18-9.77 34.09-13.84 27.69-8.1 64.74-13.87 106.52-16.05 4.91-.27 9.89-.47 14.92-.63l6.85-.18c4.47-.09 9-.15 13.55-.15h2.29c17.83 0 35.1.65 51.52 1.85q10.8.79 21.05 1.9a450.62 450.62 0 0 1 60.72 10.36c18.79 4.7 34.14 10.38 44.92 16.76q.99.58 1.99 1.21z",
    fill: "#936868"
  }), React.createElement("path", {
    d: "M515.36 692.5h-57.23l-155.11-6s-23.35-13.63-43.35-28.44c31.7-28.06 83.61-27.5 96.06-20.57 13.55 7.57 39.15 4.57 39.15 4.57 18.81-42.56 70.13-16.82 103.11 5.83a285.61 285.61 0 0 1 17.37 44.61z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M527.41 675.18s-103.91-93.37-132.53-28.62c0 0-25.6 3-39.15-4.52s-73.79-7.53-103.91 28.61-102.4 72.29-102.4 72.29 73.05 6.28 108.42 18.12c9 3 60.24-1.51 94.87-12s72.29 6 72.29 6l106.92-43.67z",
    fill: "#7fb72b"
  }), React.createElement("path", {
    d: "M536.92 709.32L430 752.99a131.49 131.49 0 0 0-34.11-8.73c-11.72-1.39-25.16-1.25-38.18 2.71-34.64 10.54-85.84 15.06-94.87 12-35.37-11.79-108.43-18.07-108.43-18.07s72.26-36.1 102.41-72.24 90.35-36.14 103.91-28.6 39.15 4.52 39.15 4.52c28.61-64.76 132.52 28.61 132.52 28.61l2.17 17.41z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M835.2 656.29c-20.45 15.45-45.77 30.18-45.77 30.18l-155.11 6H577.1a288 288 0 0 1 15-39.76c32.23-23.42 89.81-56.34 110-10.69 0 0 25.6 3 39.15-4.52 12.18-6.75 62.12-7.44 93.95 18.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M569.57 675.18s103.91-93.37 132.52-28.61c0 0 25.6 3 39.15-4.52s73.79-7.53 103.91 28.61 102.4 72.29 102.4 72.29-73.04 6.27-108.42 18.11c-9 3-60.24-1.51-94.87-12s-72.29 6-72.29 6l-106.92-43.74z",
    fill: "#7fb72b"
  }), React.createElement("path", {
    d: "M946.56 742.94s-73.05 6.28-108.43 18.12c-9 3-60.24-1.51-94.87-12-17.26-5.26-35.25-3.78-49-1a126.47 126.47 0 0 0-23.31 7l-106.9-43.74 2.73-21.79 1.79-14.35s103.91-93.37 132.52-28.61c0 0 25.6 3 39.15-4.52s73.79-7.53 103.91 28.61 102.41 72.28 102.41 72.28z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M695.29 748a126.47 126.47 0 0 0-23.31 7l-106.93-43.68 2.73-21.79c33.31-4.2 96.67 17.27 96.67 17.27s41.95 23.42 30.84 41.2zM531.92 711.32L425 754.99a131.49 131.49 0 0 0-34.11-8.73 12.34 12.34 0 0 1-.53-1.81c10.88-61.59 103.12-56.39 139.21-51.86z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M691.88 748.73c-1.31 3.51-4.46 6.85-10.1 9.82a58.69 58.69 0 0 1-9.8 4c-12.89 4.05-21.63 8.46-27.48 12.8-.35.26-.66.5-1 .75h-195c-.15-.3-.3-.54-.41-.75-.29-.5-.47-.75-.47-.75-22.83-.71-35.86-6.84-43.24-13.09-8.22-6.93-9.47-14-9.47-14 0-.21.08-.44.12-.65 9.41-50.33 73.67-55.49 116-53.25 4.2.23 8.18.51 11.87.84l2.29.21 4.71.5 2 .23c2.35.27 4.49.56 6.4.83 1.07.14 2 .29 3 .41 3.37.51 5.69.92 6.69 1.1l.56.11a17.58 17.58 0 0 1 2.2-1.49 22.25 22.25 0 0 1 3-1.45c.44-.18.89-.33 1.34-.48a47.11 47.11 0 0 1 12.41-2.18c1.37-.09 2.77-.14 4.22-.15 1.79 0 3.64 0 5.54.08s3.6.18 5.45.33c.33 0 .66 0 1 .08a232.74 232.74 0 0 1 24.49 3.6c8.67 1.7 17.15 3.73 24.65 5.71 15.71 4.14 27.14 8 27.14 8s38.43 21.4 31.89 38.84z",
    fill: "#7fb72b"
  }), React.createElement("ellipse", {
    cx: 582.47,
    cy: 359.55,
    rx: 42.13,
    ry: 27.11,
    transform: "rotate(-14.25 414.201 473.951)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M581.1 303.45s60.36-34.39 89.57-6.8c0 0-26.37 50.88-91.45 24.9z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M571.59 303.58s36.18-59.32 75.09-49.28c0 0 1.53 57.28-68 66z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M569.23 302.4s36.18-59.32 75.09-49.28c0 0 1.53 57.28-68 66z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M576.34 317.98l-1-2.36-6.1-14.39s15.82-25.93 37.77-40.59c11.26-7.53 24.13-12.1 37.31-8.69.01-.01 1.54 57.28-67.98 66.03z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M607.01 260.63c-.86 16.25-8.26 35.95-31.57 55.06l-.11-.07-6.1-14.39s15.83-25.93 37.78-40.6z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M573.08 315.69l-3.36-2.35-11.57-8.05s-.41-30 10.19-54.08c5.52-12.53 14-23.43 27.14-27.61 0 0 31.8 47.67-22.4 92.09z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M570.17 313.37h-.45l-11.57-8.05s-.41-30 10.19-54.08c7.45 14.16 11.14 34.4 1.83 62.13z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M549.67 312.49s-37.72-58.35-11.78-89c0 0 52.27 23.5 30 89.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M540.67 315.64s-53.87-43.89-38.65-81.07c0 0 57 6.24 56.21 76.31z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M538.27 315.64s-53.87-43.89-38.6-81.07c0 0 57 6.24 56.21 76.31z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M532.2 323.18s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M531.02 325.54s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M527.52 337s-68.17 13.45-87.08-22c0 0 41.17-39.86 94.62 5.44z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M526.34 339.36s-68.17 13.45-87.08-22c0 0 41.17-39.86 94.62 5.44z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M537.48 334.7s-49.68 48.58-84.92 29.26c0 0 12.63-55.9 82.16-47.25z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M539.84 337.06s-49.68 48.58-84.92 29.26c0 0 12.63-55.9 82.16-47.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M535.67 329.31s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M539.24 330.49s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M562.22 334.06s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M564.58 334.06s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M555.87 335.48s57.33 39.26 45.25 77.58c0 0-57.29-1.49-62.36-71.38z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M558.23 335.48s57.33 39.26 45.25 77.58c0 0-57.29-1.49-62.36-71.38z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M571.52 326.36s70.85 17.1 78.78 63.7c0 0-52.28 23.55-91.13-49.49z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M573.88 325.18s70.85 17.1 78.78 63.68c0 0-52.28 23.55-91.13-49.49zM549.67 312.49s-37.72-58.35-11.78-89c0 0 52.27 23.5 30 89.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M549.67 312.49s-37.72-58.35-11.78-89c0 0 52.27 23.5 30 89.92z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M531.02 325.54s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M531.02 325.54s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M539.84 337.06s-49.68 48.58-84.92 29.26c0 0 12.63-55.9 82.16-47.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M539.84 337.06s-49.68 48.58-84.92 29.26c0 0 12.63-55.9 82.16-47.25z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M564.58 334.06s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M564.58 334.06s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M573.88 325.18s70.85 17.1 78.78 63.68c0 0-52.28 23.55-91.13-49.49z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M573.88 325.18s70.85 17.1 78.78 63.68c0 0-52.28 23.55-91.13-49.49z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M580.67 315.16s72.83 2.66 89.88 46.73c0 0-46.54 33.49-99.15-30.36z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M581.85 309.27s72.83 2.66 89.88 46.73c0 0-46.54 33.49-99.15-30.36z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M581.85 312.8s72.83 2.66 89.88 46.73c0 0-46.54 33.49-99.15-30.36z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M599.88 331.63a42.87 42.87 0 1 1-31.23-52 42.88 42.88 0 0 1 31.23 52z",
    fill: "#feea59"
  }), React.createElement("ellipse", {
    cx: 325.46,
    cy: 186.25,
    rx: 42.13,
    ry: 27.11,
    transform: "rotate(-14.25 157.14 300.606)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M324.09 130.14s60.36-34.41 89.56-6.8c0 0-26.37 50.88-91.45 24.9z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M314.58 130.27s36.18-59.32 75.09-49.28c0 0 1.53 57.28-68 66z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M312.22 129.06s36.18-59.32 75.09-49.28c0 0 1.53 57.28-68 66z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M319.32 144.67l-1-2.36-6.1-14.39s15.82-25.93 37.77-40.59c11.26-7.53 24.13-12.1 37.31-8.69.01 0 1.55 57.28-67.98 66.03z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M350 87.33c-.86 16.25-8.26 35.95-31.57 55.06l-.11-.07-6.1-14.39s15.83-25.94 37.78-40.6z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M316.07 142.38l-3.4-2.32-11.57-8.05s-.41-30 10.19-54.08c5.52-12.53 14-23.43 27.14-27.61.04-.02 31.84 47.64-22.36 92.06z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M313.16 140.06h-.45l-11.57-8.05s-.41-30 10.19-54.08c7.45 14.13 11.14 34.4 1.83 62.13z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M292.67 139.18s-37.72-58.35-11.78-89c0 0 52.27 23.5 30 89.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M283.62 142.33s-53.87-43.88-38.65-81.07c0 0 57 6.24 56.21 76.31z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M281.26 142.33s-53.87-43.89-38.65-81.07c0 0 57 6.24 56.21 76.31z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M275.19 149.88s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M274.01 152.24s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M270.51 163.69s-68.17 13.45-87.08-22c0 0 41.17-39.86 94.62 5.44z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M269.33 166.06s-68.17 13.45-87.08-22c0 0 41.17-39.86 94.62 5.44z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M280.47 161.4s-49.68 48.58-84.92 29.26c0 0 12.63-55.9 82.16-47.25z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M282.83 163.76s-49.68 48.58-84.92 29.3c0 0 12.63-55.9 82.16-47.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M278.67 156.01s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M282.22 157.19s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M305.21 160.79s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M307.57 160.79s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M298.86 162.18s57.33 39.26 45.25 77.58c0 0-57.29-1.49-62.36-71.38z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M301.21 162.18s57.33 39.26 45.25 77.58c0 0-57.29-1.49-62.36-71.38z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M314.51 153.06s70.85 17.1 78.78 63.68c0 0-52.28 23.55-91.13-49.49z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M316.87 151.88s70.8 17.1 78.8 63.68c0 0-52.28 23.55-91.13-49.49zM292.67 139.18s-37.72-58.35-11.78-89c0 0 52.27 23.5 30 89.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M292.67 139.18s-37.72-58.35-11.78-89c0 0 52.27 23.5 30 89.92z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M274.01 152.24s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M274.01 152.24s-67.48-16.58-69.65-56.7c0 0 54.15-18.76 83.48 44.88z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M282.83 163.76s-49.68 48.58-84.92 29.3c0 0 12.63-55.9 82.16-47.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M282.83 163.76s-49.68 48.58-84.92 29.3c0 0 12.63-55.9 82.16-47.25z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M307.57 160.79s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M307.57 160.79s8.2 69-28.6 85.14c0 0-36.6-44.1 12.67-93.93z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M316.87 151.88s70.8 17.1 78.8 63.68c0 0-52.28 23.55-91.13-49.49z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M316.87 151.88s70.8 17.1 78.8 63.68c0 0-52.28 23.55-91.13-49.49z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M323.67 141.85s72.83 2.66 89.88 46.73c0 0-46.54 33.49-99.15-30.36z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M324.84 135.96s72.83 2.66 89.83 46.73c0 0-46.54 33.49-99.15-30.36z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M324.84 139.5s72.83 2.66 89.83 46.73c0 0-46.54 33.49-99.15-30.36z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M342.87 158.32a42.87 42.87 0 1 1-31.23-52 42.88 42.88 0 0 1 31.23 52z",
    fill: "#feea59"
  }), React.createElement("ellipse", {
    cx: 821.82,
    cy: 251.11,
    rx: 42.13,
    ry: 27.11,
    transform: "rotate(-40.31 753.395 277.544)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M809.22 182.82s39.12-57.43 77.47-45.44c0 0-1.35 57.29-71.22 62.53z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M800.74 187.06s6.45-69.19 45.82-77.25c0 0 26.53 50.79-32.08 89.18z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M798.1 187.06s6.45-69.19 45.82-77.25c0 0 26.53 50.79-32.08 89.18z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M811.33 197.96l-1.94-1.68-11.8-10.22s2.83-30.24 16.11-53.06c6.81-11.71 16.37-21.47 29.71-24.19 0-.03 26.53 50.76-32.08 89.15z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M813.67 132.97c6.36 15 8.36 35.92-4.18 63.33h-.13l-11.77-10.24s2.83-30.27 16.08-53.09z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M807.4 197.34l-4-.63-13.93-2.15s-13.56-26.81-14.6-53.06c-.55-13.68 2.32-27.21 12.26-36.72-.05-.01 49.45 28.85 20.27 92.56z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M803.76 196.53l-.41.18-13.93-2.15s-13.56-26.81-14.6-53.06c12.93 9.46 25.13 26.03 28.94 55.03z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M784.93 204.76s-59.52-35.86-49.69-74.82c0 0 57.28-1.85 66.4 67.63z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M778.22 211.55s-67.67-15.76-70.33-55.86c0 0 53.92-19.41 84 43.87z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M776.1 212.58s-67.67-15.76-70.33-55.86c0 0 53.92-19.41 84 43.87z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M773.96 222.06s-67.9 14.74-87.48-20.35c0 0 40.41-40.63 94.71 3.65z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M773.94 224.66s-67.9 14.74-87.48-20.35c0 0 40.41-40.63 94.71 3.65z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M775.83 236.49s-55.33 42-87.89 18.48c0 0 19.48-53.89 87.4-36.67z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M775.8 239.13s-55.33 42-87.89 18.48c0 0 19.48-53.89 87.4-36.67z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M783.77 230.06s-23.3 65.46-63.44 63.58c0 0-13.2-55.76 53.07-78.53z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M786.92 231.14s-23.3 65.46-63.44 63.58c0 0-13.2-55.76 53.07-78.53z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M779.8 226s37.67 58.39 11.7 89c0 0-52.25-23.54-29.87-89.95z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M783.49 225.5s37.67 58.39 11.7 89c0 0-52.25-23.54-29.87-89.95z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M805.73 218.64s37.67 58.39 11.7 89c0 0-52.25-23.54-29.87-89.95z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M807.85 217.61s37.67 58.39 11.7 89c0 0-52.25-23.54-29.87-89.95z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M800.67 222.68s68.75 10.09 74.73 49.82c0 0-52.12 23.82-87.37-36.74z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M802.75 221.65s68.75 10.09 74.73 49.82c0 0-52.12 23.82-87.37-36.74z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M810.67 207.61s71.16-15.75 98.74 22.61c0 0-36.62 44.12-103.6-4.44z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M812.28 205.52s71.16-15.75 98.74 22.61c0 0-36.62 44.12-103.6-4.44zM784.93 204.76s-59.52-35.86-49.69-74.82c0 0 57.28-1.85 66.4 67.63z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M784.93 204.76s-59.52-35.86-49.69-74.82c0 0 57.28-1.85 66.4 67.63z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M773.94 224.66s-67.9 14.74-87.48-20.35c0 0 40.41-40.63 94.71 3.65z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M773.94 224.66s-67.9 14.74-87.48-20.35c0 0 40.41-40.63 94.71 3.65z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M786.92 231.14s-23.3 65.46-63.44 63.58c0 0-13.2-55.76 53.07-78.53z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M786.92 231.14s-23.3 65.46-63.44 63.58c0 0-13.2-55.76 53.07-78.53z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M807.85 217.61s37.67 58.39 11.7 89c0 0-52.25-23.54-29.87-89.95z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M807.85 217.61s37.67 58.39 11.7 89c0 0-52.25-23.54-29.87-89.95z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M812.28 205.52s71.16-15.75 98.74 22.61c0 0-36.62 44.12-103.6-4.44z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M812.28 205.52s71.16-15.75 98.74 22.61c0 0-36.62 44.12-103.6-4.44z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M813.98 193.53s66.6-29.6 101.27 2.51c0 0-27.11 50.52-102.41 16.27z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M812.45 187.72s66.6-29.6 101.27 2.51c0 0-27.11 50.52-102.41 16.27z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M814.01 190.89s66.6-29.6 101.27 2.51c0 0-27.11 50.52-102.41 16.27z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M838.47 199.89a42.87 42.87 0 1 1-50.89-33 42.88 42.88 0 0 1 50.89 33z",
    fill: "#feea59"
  }), React.createElement("ellipse", {
    cx: 780.48,
    cy: 439.61,
    rx: 42.13,
    ry: 27.11,
    transform: "rotate(-39.4 710.936 467.193)",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M768.36 371.65s40-56.81 78.18-44.22c0 0-2.25 57.26-72.2 61.4z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M759.81 375.81s7.54-69.08 47-76.52c0 0 25.73 51.2-33.48 88.67z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M757.17 375.74s7.54-69.08 47-76.52c0 0 25.73 51.2-33.48 88.67z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M770.22 386.82l-1.91-1.71-11.64-10.43s3.3-30.19 16.94-52.8c7-11.6 16.7-21.21 30.08-23.72-.02 0 25.75 51.2-33.47 88.66z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M773.62 321.88c6.13 15.07 7.8 36.05-5.18 63.26h-.13l-11.64-10.46s3.31-30.19 16.95-52.8z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M766.3 386.14l-4-.7-13.93-2.38s-13.14-27-13.76-53.28c-.33-13.69 2.74-27.17 12.83-36.53 0 .01 49.04 29.64 18.86 92.89z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M762.67 385.27l-.42.17-13.88-2.38s-13.14-27-13.76-53.28c12.77 9.68 24.72 26.43 28.06 55.49z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M743.67 393.2s-58.95-36.79-48.51-75.59c0 0 57.3-.94 65.33 68.66z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M736.91 399.88s-67.42-16.83-69.44-57c0 0 54.22-18.56 83.31 45.19z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M734.77 400.89s-67.42-16.83-69.44-57c0 0 54.22-18.56 83.31 45.19z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M732.48 410.3s-68.13 13.67-87.15-21.73c0 0 41-40 94.64 5.15z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M732.42 412.93s-68.13 13.67-87.15-21.73c0 0 41-40 94.64 5.15z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M734.12 424.79s-56 41.15-88.17 17.09c0 0 20.32-53.58 88-35.29z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M734.05 427.42s-56 41.15-88.17 17.09c0 0 20.32-53.58 88-35.29z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M742.16 418.48s-24.33 65.09-64.43 62.58c0 0-12.32-56 54.3-77.69z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M745.3 419.61s-24.33 65.09-64.43 62.57c0 0-12.32-56 54.3-77.69z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M738.25 414.36s36.75 59 10.3 89.22c0 0-51.87-24.36-28.45-90.41z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M741.96 413.92s36.75 59 10.3 89.22c0 0-51.87-24.36-28.45-90.41z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M764.3 407.41s36.75 59 10.3 89.22c0 0-51.87-24.36-28.45-90.41z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M766.43 406.41s36.75 59 10.3 89.22c0 0-51.87-24.36-28.45-90.41z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M759.13 411.37s68.58 11.17 73.93 51c0 0-52.49 23-86.78-38.11z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M761.27 410.37s68.58 11.17 73.93 51c0 0-52.49 23-86.78-38.11z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M769.42 396.46s71.4-14.63 98.38 24.16c0 0-37.31 43.54-103.52-6.07z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M771.06 394.39s71.4-14.63 98.38 24.16c0 0-37.31 43.54-103.52-6.07zM743.67 393.2s-58.95-36.79-48.51-75.59c0 0 57.3-.94 65.33 68.66z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M743.67 393.2s-58.95-36.79-48.51-75.59c0 0 57.3-.94 65.33 68.66z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M732.42 412.93s-68.13 13.67-87.15-21.73c0 0 41-40 94.64 5.15z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M732.42 412.93s-68.13 13.67-87.15-21.73c0 0 41-40 94.64 5.15z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M745.3 419.61s-24.33 65.09-64.43 62.57c0 0-12.32-56 54.3-77.69z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M745.3 419.61s-24.33 65.09-64.43 62.57c0 0-12.32-56 54.3-77.69z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M766.43 406.41s36.75 59 10.3 89.22c0 0-51.87-24.36-28.45-90.41z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M766.43 406.41s36.75 59 10.3 89.22c0 0-51.87-24.36-28.45-90.41z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M771.06 394.39s71.4-14.63 98.38 24.16c0 0-37.31 43.54-103.52-6.07z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M771.06 394.39s71.4-14.63 98.38 24.16c0 0-37.31 43.54-103.52-6.07z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M772.95 382.43s67.06-28.54 101.22 4.11c0 0-27.9 50.09-102.65 14.65z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M771.51 376.6s67.06-28.54 101.22 4.1c0 0-27.9 50.09-102.65 14.65z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M773.01 379.8s67.06-28.54 101.22 4.11c0 0-27.9 50.09-102.65 14.65z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M797.33 389.18a42.87 42.87 0 1 1-50.36-33.78 42.88 42.88 0 0 1 50.36 33.78z",
    fill: "#feea59"
  }), React.createElement("path", {
    d: "M300.46 367.06c3.44 12.47 15.37 20.05 15.37 20.05s6.37-12.63 2.93-25.1-15.37-20.05-15.37-20.05-6.36 12.65-2.93 25.1zM364.77 436.51c-3.7 12.39 2.4 25.15 2.4 25.15s12.09-7.33 15.79-19.72-2.4-25.15-2.4-25.15-12.09 7.32-15.79 19.72zM828.67 516.22c-9.08 9.21-9.67 23.34-9.67 23.34s14.12-.8 23.2-10 9.67-23.34 9.67-23.34-14.2.84-23.2 10z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M983.18 717.76s1.79 26.22 4.77 29.2-26.82 4.77-26.82 4.77l4.17-34z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M983.18 717.76s1.79 26.22 4.77 29.2-26.82 4.77-26.82 4.77l4.17-34z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M989.73 738.06s-4.17 0-19.07 7.75c0 0-10.13-1.79-14.3-16.09 0 0-12.51 21.45-20.86 22.64s-24.43 2.35-13.7 16.7 73.87 7.7 73.87 7.7 1.81-34.56-5.94-38.7z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M989.73 738.06s-4.17 0-19.07 7.75c0 0-10.13-1.79-14.3-16.09 0 0-12.51 21.45-20.86 22.64s-24.43 2.35-13.7 16.7 73.87 7.7 73.87 7.7 1.81-34.56-5.94-38.7z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M980.79 758.28l-4.12 11.33-27.41-7.75 1.56-11.24.38-2.71 1-7.5s23.24-6 23.24-3a46.23 46.23 0 0 0 1.53 7.26c1 3.66 2.15 7.84 3 10.59.47 1.8.82 3.02.82 3.02z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M965.84 602.88c-1.88 3.18-4 9.14-.05 16.58a28.87 28.87 0 0 0 4.28 5.94c13.11 14.3 16.69 46.48 16.69 46.48v51.84l-8.94.69-14.3 1.1-21.45-88.19s-12.51-64.36-6.55-75.68 11.32-82.23 11.32-82.23l4.95-5.12 11.74-12.16h34a22.84 22.84 0 0 1 6.61 7.39c5.7 9.44 10.82 29.07-4.82 65.31-24.43 56.61-31.58 65.55-31.58 65.55a13.73 13.73 0 0 0-1.9 2.5z",
    fill: "#4c4c78"
  }), React.createElement("path", {
    d: "M965.84 602.88c-1.88 3.18-4 9.14-.05 16.58a28.87 28.87 0 0 0 4.28 5.94c13.11 14.3 16.69 46.48 16.69 46.48v51.84l-8.94.69-14.3 1.1-21.45-88.19s-12.51-64.36-6.55-75.68 11.32-82.23 11.32-82.23l4.95-5.12 11.74-12.16h34a22.84 22.84 0 0 1 6.61 7.39c5.7 9.44 10.82 29.07-4.82 65.31-24.43 56.61-31.58 65.55-31.58 65.55a13.73 13.73 0 0 0-1.9 2.5z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M976.96 744.69l-25.81 3.22 1-7.5s23.24-6 23.24-3a46.23 46.23 0 0 0 1.57 7.28z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M964.11 526.48s1.48 46.91 1.73 76.39c.05 6.67 0 12.45-.05 16.58a36.74 36.74 0 0 1-.48 6.54c-1.79 5.36 1.79 17.28 1.79 17.28 14.9 39.33 10.73 73.89 10.73 73.89v26.22l-28.6 3.58s4.77-3.58-8.34-38.14c-7.53-19.86-9.16-39.31-9.19-52.28a55.94 55.94 0 0 0-4.18-20.68 25.52 25.52 0 0 1-1.53-6.89c-1.19-11.92-6.55-26.82-6.55-26.82s-14.3-42.31-17.88-73.3a170.67 170.67 0 0 1 .83-44.33 110.63 110.63 0 0 1 2.15-11.09s58.25-36.66 80.25-11.32a28.69 28.69 0 0 1 5 8.34 55.06 55.06 0 0 1 2.81 9.28c6.79 33.65-28.49 46.75-28.49 46.75z",
    fill: "#4c4c78"
  }), React.createElement("circle", {
    cx: 962.33,
    cy: 235.09,
    r: 30.39,
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M945.67 254.16s12.51 35.16 0 53.63 39.92 12.51 39.92 12.51l20.26-24.43s-23.84 0-25-41.71-35.18 0-35.18 0z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M1005.82 476.43a78.2 78.2 0 0 1-13.28 3.33c-7.42 1.14-16.17 1.19-21.29-3.33-3-2.68-10.51-3-19.49-2.15-18.91 1.81-44.51 8.87-49.41 10.26a110.63 110.63 0 0 1 2.15-11.09s58.25-36.66 80.25-11.32h12.71a22.84 22.84 0 0 1 6.61 7.39c1.11 4.74 1.75 6.91 1.75 6.91zM980.79 758.28l-4.12 11.33-27.41-7.75 1.56-11.24c4.71 10.42 12.74 11.83 12.74 11.83 8.66-4.5 13.7-6.39 16.4-7.18.48 1.79.83 3.01.83 3.01z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M982.58 755.31s-4.17 0-19.07 7.75c0 0-10.13-1.79-14.3-16.09 0 0-12.51 21.45-20.86 22.64s-24.43 2.38-13.71 16.69 73.89 7.75 73.89 7.75 1.8-34.57-5.95-38.74z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M841.21 240.91s1.16-23.21 25.55-20.94a4.17 4.17 0 0 1 3.29 6.1l-5 9.41z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M981.99 303.06s-29.2-4.77-36.95-10.73c0 0-6 11.32-16.69 5.36s-35.75-5.36-35.75-5.36-20.86-11.32-25-36.95c0 0-4.17-15.49-3-19.66 0 0-15.49-16.09-23.24 5.36 3 14.9 5.36 13.71 4.77 25.62l9.54 26.19s.6 8.94 17.88 20.86 36.95 30.39 36.95 30.39-10.43 5.66-6.55 31.58c4.73 31.68-2.38 76.87-2.38 76.87v29.2s59.59-17.28 69.72-8.34 34.56 0 34.56 0-3-10.13-7.15-34.56.6-48.27.6-48.27 15.49-41.12 22.64-57.8-5.36-39.33-17.88-47.67-17.17-3.33-17.17-3.33 21.91 15.84-4.9 21.24z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M929.45 227.66a10.54 10.54 0 0 0 .62 3.64 11.48 11.48 0 0 0 2.79 3.47c4.46 4.36 8.38 9.54 9.95 15.58 1.06 4.09 1 8.37.94 12.6-.26 17.11-1 35.58-11.54 49-3.88 4.95-8.88 8.88-13.57 13.07a4.09 4.09 0 0 0-1.43 1.91 3.57 3.57 0 0 0 .44 2.36c2.18 4.53 6.77 7.31 11.12 9.83 2 1.15 4.08 2.34 6.38 2.41 5.42.18 9-5.55 13.93-7.8 7.18-3.28 15.23 1.28 22.36 4.68a78.79 78.79 0 0 0 16.14 5.63c7.63 1.76 16.25 2.19 22.67-2.28a17.31 17.31 0 0 0 7.06-11.05c.52-2.91.44-6.29 2.64-8.26 1.14-1 2.69-1.44 3.91-2.34 1.91-1.4 2.81-3.75 3.62-6l7.34-20.07a16.49 16.49 0 0 0 1.43-6.74c-.35-4.83-4.81-8.34-9.28-10.2s-9.42-2.77-13.36-5.6c-6.65-4.78-8.71-13.71-9.31-21.88a105.34 105.34 0 0 1 .12-16.85c.73-8.31 2.35-17.17-1.35-24.65-3.95-8-12.81-12.07-21-15.55-3.15-1.34-6.39-2.69-9.81-2.84-3.62-.16-7.14 1-10.56 2.23-5.44 1.89-11 4.33-16.57 5.61-3.15.72-6.61.18-9.65 1.32-11.16 4.23-6.03 19.77-6.03 28.77z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M929.45 226.47a10.54 10.54 0 0 0 .62 3.64 11.48 11.48 0 0 0 2.79 3.47c4.46 4.36 8.38 9.54 9.95 15.58 1.06 4.09 1 8.37.94 12.6-.26 17.11-1 35.58-11.54 49-3.88 4.95-8.88 8.88-13.57 13.07a4.09 4.09 0 0 0-1.43 1.91 3.57 3.57 0 0 0 .44 2.36c2.18 4.53 6.77 7.31 11.12 9.83 2 1.15 4.08 2.34 6.38 2.41 5.42.18 9-5.55 13.93-7.8 7.18-3.28 15.23 1.28 22.36 4.68a78.79 78.79 0 0 0 16.14 5.63c7.63 1.76 16.25 2.19 22.67-2.28a17.31 17.31 0 0 0 7.06-11.05c.52-2.91.44-6.29 2.64-8.26 1.14-1 2.69-1.44 3.91-2.34 1.91-1.4 2.81-3.75 3.62-6l7.34-20.07a16.49 16.49 0 0 0 1.43-6.74c-.35-4.83-4.81-8.34-9.28-10.2s-9.42-2.77-13.36-5.6c-6.65-4.78-8.71-13.71-9.31-21.88a105.34 105.34 0 0 1 .12-16.85c.73-8.31 2.35-17.17-1.35-24.65-3.95-8-12.81-12.07-21-15.55-3.15-1.34-6.39-2.69-9.81-2.84-3.62-.16-7.14 1-10.56 2.23-5.44 1.89-11 4.33-16.57 5.61-3.15.72-6.61.18-9.65 1.32-11.16 4.23-6.03 19.77-6.03 28.77z",
    fill: "#b96b6b"
  }), React.createElement("path", {
    d: "M905.43 389.06s4.75-1.15 28.59-4.73 65.55 4.77 65.55 4.77",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M250.46 487.06c3.44 12.47 15.37 20.05 15.37 20.05s6.37-12.63 2.93-25.1-15.37-20.05-15.37-20.05-6.36 12.65-2.93 25.1z",
    fill: primaryColor
  }));
};

UndrawGardening.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawGardening;